import { Http, safeJsonParse } from 'vrlcm-gui-utils';
import {
  ReplaceLicenseDTO,
  License,
  LicenseAssociationRequest,
  LicenseAssociationResponse,
  LicenseValidationResponse,
  LicenseValidationRequestDto,
  RequestId,
  LicenseAttribute
} from 'vrlcm-gui-types';
import { LockerApiUri } from './uri';
import { RequestApi } from '../request';

export class LicenseApi {
  public static async getLicenses(legacyOnly?: any) {
    const url = legacyOnly?.payload?.legacyOnly
      ? LockerApiUri.License.NON_EVALUATION_LICENSES_URL(true)
      : LockerApiUri.License.LICENSES_BASE_URL;
    const response = await Http.get<License[]>(url);
    return response.data;
  }

  public static async getContainerLicenses() {
    const response = await Http.get<License[]>(
      LockerApiUri.License.CONTAINER_LICENSES_URL
    );
    return response.data;
  }

  public static async getLicenseByVmid(vmid: string) {
    const response = await Http.get<License>(
      LockerApiUri.License.GET_LICENSE_BY_VMID_URL(vmid)
    );
    return response.data;
  }

  public static async getLicenseByAlias(alias: string) {
    const response = await Http.get<License>(
      LockerApiUri.License.GET_LICENSE_BY_ALIAS_URL(alias)
    );
    return response.data;
  }

  public static async validateLicense(payload: LicenseValidationRequestDto) {
    const response = await Http.post<LicenseValidationResponse>(
      LockerApiUri.License.VALIDATE_LICENSE_URL,
      payload
    );
    return response.data;
  }
  public static async disconnectSaasEndpoint(vmid: string) {
    const payload = {
      isConnected: false,
      licenseId: vmid
    };
    const response = await Http.put<RequestId>(
      LockerApiUri.License.SAAS_ENDPOINT_DISCONNECT_URL(vmid),
      payload
    );
    return response.data;
  }

  public static async getValidateLicenseData(requestId: string) {
    const request = await RequestApi.pollRequestForCompletion(requestId);
    const license = safeJsonParse<LicenseAttribute>(
      safeJsonParse(
        safeJsonParse(safeJsonParse(request.resultSet)[0].resultText)
      )
    );
    return license;
  }

  public static async addLicense(payload: LicenseAttribute) {
    const response = await Http.post<License>(
      LockerApiUri.License.LICENSES_BASE_URL,
      payload
    );
    return response.data;
  }

  public static async getProductLicense(
    environmentId: string,
    productId: string,
    tenantId: string
  ) {
    const response = await Http.get<License[]>(
      LockerApiUri.License.GET_PRODUCT_LICENSE_URL(
        environmentId,
        productId,
        tenantId
      )
    );
    return response.data;
  }

  public static async validateAssociations(
    payload: LicenseAssociationRequest,
    vsscSelectedProductTenantId?: string
  ) {
    const response = await Http.post<LicenseAssociationResponse>(
      LockerApiUri.License.GET_LICENSE_ASSOCIATION_URL(
        vsscSelectedProductTenantId
      ),
      payload
    );
    return response.data;
  }

  public static async getValidProductLicensesForEnvironment(
    environmentId: string,
    productId: string,
    payload: LicenseAssociationRequest,
    tenantId: string
  ) {
    const response = await Http.post<LicenseAssociationResponse>(
      LockerApiUri.License.GET_VALID_PRODUCT_LICENSES_URL(
        environmentId,
        productId,
        tenantId
      ),
      payload
    );
    return response.data;
  }

  public static async replaceLicenseForAssociations(
    payload: ReplaceLicenseDTO
  ) {
    const res = await Http.post(
      LockerApiUri.License.REPLACE_LICENSE_URL(payload.vmid),
      payload
    );
    return res.data;
  }
}
